import * as React from 'react'
const PhoneImg = require('src/assets/phone_clever.png')

const PhoneNumber = (props) => {
  return (
    <a className='phone-item' href='tel:0043800884404'>
      <img src={PhoneImg} />
      <p>01 907 68 85</p>
    </a>
  )
}

export default PhoneNumber



// WEBPACK FOOTER //
// ./src/components/atoms/PhoneNumberClever.tsx